type Props = {
  width?: number,
  height?: number,
  fill?: string,
  className?: string,
}

const ArrowRoundedCornerIcon = ({ width = 13, height = 16, fill = '#535577', className }: Props) =>
  <svg
  width={width} height={height} fill='none' viewBox='0 0 13 16' className={className}>
    <path d="M6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3H6ZM13 10H10V16H13V10ZM6 6V3H0V6H6ZM10 10C7.79086 10 6 8.20914 6 6H0C0 11.5228 4.47715 16 10 16V10Z" fill={ fill } />
  </svg>
{/* <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">

    <path d='M4 2C4 0.895431 3.10457 0 2 0C0.895431 0 0 0.895431 0 2H4ZM12 10H9V14H12V10ZM4 5V2H0V5H4ZM9 10C6.23858 10 4 7.76142 4 5H0C0 9.97056 4.02944 14 9 14V10Z' fill={fill} />
  </svg> */}

export default ArrowRoundedCornerIcon
